(function () {
  let currentLang = $('.controls__description').find('input.lang-input').eq(0).data('language');

  const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  const select = $(".select-cart-size");
  const customSizeOption = $('#custom_size');
  const saveCustomSize = $('#saveCustomSize');
  const clearCustomSize = $('#clearCustomSize');
  const fields = $('.custom-size__form-measuring input');
  const labels = $('.measuring-description');
  const measuringOptions = $('.measuring');

  const customSize = localStorage.getItem("pintel_custom_size");

  const newCustomSize = {};

  let selectedMeasuring = '';

  fields.each(function (index) {
    fields.eq(index).attr('centimeters', '');
    fields.eq(index).attr('inches', '');
  });

  if (customSize) {
    const prevCustomSize = JSON.parse(customSize);
    const units = prevCustomSize.measure === 'centimeters' ? ['centimeters', 'inches'] : ['inches', 'centimeters'];
    const isCentimeters = prevCustomSize.measure === 'centimeters';
    $('#measure-' + prevCustomSize.measure).click();

    fields.each(function (index) {
      fields.eq(index).removeClass('_error');
      fields[index].value = prevCustomSize[fields[index].id];
      const getValue = prevCustomSize[fields[index].id];
      const value = +getValue;
      const valueWithCorrectRounding = isCentimeters ? Number(value).toFixed(1) : Number(value).toFixed(2);
      fields.eq(index).attr(units[0], parseFloat(valueWithCorrectRounding));
      const secondValue = isCentimeters ? +value / 2.54 : +value * 2.54;
      const secondValueWithCorrectRounding = isCentimeters ? Number(secondValue).toFixed(2) : Number(secondValue).toFixed(1);
      fields.eq(index).attr(units[1], parseFloat(secondValueWithCorrectRounding));
      labels.eq(index).addClass('_visible');
    });
  }

  saveCustomSize.click(function () {
    let countError = 0;
    const isCentimeters = selectedMeasuring !== 'inches';
    const measure = isCentimeters ? 'centimeters' : 'inches';
    fields.each(function (index) {
      fields.eq(index).removeClass('_error');
      labels.eq(index).addClass('_visible');
      if (!fields[index].value.length) {
        fields.eq(index).addClass('_error');
        labels.eq(index).removeClass('_visible');
        countError++;
      }
      const correctedValue = isCentimeters ? Number(fields[index].value).toFixed(1) : Number(fields[index].value).toFixed(2);
      newCustomSize[fields[index].id] = parseFloat(correctedValue);
    });

    if (!countError) {
      newCustomSize.measure = measure;
      newCustomSize.strMeasure = isCentimeters ? 'см' : '″'
      const stringCustomSize = JSON.stringify(newCustomSize);
      localStorage.setItem("pintel_custom_size", stringCustomSize);

      $.each($(".dropdown-menu__item"), function () {
        $(this).removeClass('active');
      });
      customSizeOption.addClass('active');
      select.find('.custom-select-name').html(customSizeOption.text());

      $('.action-menu.custom-size-menu').removeClass('active');
      $('html').removeClass('no--scroll');
    } else {
      const $modalAttention = $('.modal-attention');
      const message = currentLang === 'en' ? 'Please fill in the required fields.' : 'Пожалуйста, заполните обязательные поля.';
      $modalAttention.fadeIn(500).find('.modal__text').html(message);
      setTimeout(function () {
        $modalAttention.fadeOut(500);
      }, 3500);
    }
  });

  clearCustomSize.click(function () {
    fields.each(function (index) {
      fields.eq(index).attr('centimeters', '');
      fields.eq(index).attr('inches', '');
    });
    $('#measure-centimeters').click();
    $('.measuring-description').removeClass('_visible');

    localStorage.removeItem("pintel_custom_size");

    $(".select-cart-size").find('#custom_size').removeClass('active');
    select.find('.custom-select-name').html(select.find('.custom-select-name').data('no-selected'));
  });

  measuringOptions.click(function () {
    $(this).attr('checked', true);
    selectedMeasuring = $(this).attr('data-measure');
    const isCentimeters = selectedMeasuring !== 'inches';
    const unit = isCentimeters ? 'centimeters' : 'inches';
    fields.each(function (index) {
      fields[index].value = fields.eq(index).attr(unit);
    });
  })

  let scr = 0;

  $(window).scroll(function () {
    scr = scrollY;
    scrCurrency = scrollY;
  });

  // ------ fields events

  $(fields).bind('blur', function (e) {
    if (!e.target.value.length) {
      const fieldIndex = fields.index(this);
      labels.eq(fieldIndex).removeClass('_visible');
      const isCentimeters = selectedMeasuring !== 'inches';
      const units = isCentimeters ? ['centimeters', 'inches'] : ['inches', 'centimeters'];
      fields.eq(fieldIndex).attr(units[0], '');
      fields.eq(fieldIndex).attr(units[1], '');
    }
  });

  $(fields).bind('focus', function (e) {
    const fieldIndex = fields.index(this);
    $(this).removeClass('_error');
    labels.eq(fieldIndex).addClass('_visible');

    //iOS focus fix
    if (iOS && this.value === "" ){
      this.value=""
    }
  });

  if (fields) {
    fields.on("input", function(e){
      const isCentimeters = selectedMeasuring !== 'inches';
      const units = isCentimeters ? ['centimeters', 'inches'] : ['inches', 'centimeters'];

      const targetValue = e.target.value;

      const value = targetValue[targetValue.length-1]==="," ?
        targetValue.substring(0, targetValue.length-1) + "." :
        targetValue;

      if (!value.match(/^[0-9]*\.?([0-9]+)?$/g)){
        e.target.value = value.substring(0, value.length-1)
        return false
      }

      e.target.value = value;

      if (value.length > 0) {
        const valueWithCorrectRounding = isCentimeters ? Number(value).toFixed(1) : Number(value).toFixed(2);
        $(this).attr(units[0], parseFloat(valueWithCorrectRounding));

        const secondValue = isCentimeters ? +value / 2.54 : +value * 2.54;

        const secondValueWithCorrectRounding = isCentimeters ? Number(secondValue).toFixed(2) : Number(secondValue).toFixed(1);
        $(this).attr(units[1], parseFloat(secondValueWithCorrectRounding));

        return true
      }

      return false
    });
  }
})();
